import React, { Component } from 'react';
import classes from './TimeSelect.css';

class TimeSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      time: '',
    };
    //console.log('WHAT IS PROPS', props)
    if (this.props.time) {
      this.setState.time = this.props.time;
    }
    this.hours = this.convertTo12Hours(this.get24Hours());
    this.handleTimeChange = this.handleTimeChange.bind(this);
  }

  handleTimeChange(event) {
    //console.log("Timeselect event.target", event.target.value);
    this.setState({ time: event.target.value });
    this.props.handleTimeChange(event.target.value);
  }

  get24Hours() {
    let hours = [];
    for (var h = 0; h < 24; h++) {
      for (var m = 0; m < 60; m++) {
        hours.push(
          h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0')
        );
      }
    }
    return hours;
  }

  convertTo12Hours(hours) {
    return hours.reduce((acc, hour) => {
      let hrs = hour.split(':');
      let hr = parseInt(hrs[0], 10);
      let m = hrs[1];

      let remainder = hr % 12;
      let h = remainder === 0 ? 12 : remainder;

      let ampm = hr < 12 ? 'AM' : 'PM';
      let value = h + ':' + m + ' ' + ampm;
      acc[hour] = value;
      return acc;
    }, {});
  }

  render() {
    //console.log("TimeSelect this.props", this.props, "state", this.state);

    let disableValue = this.props.startTime
      ? this.props.startTime.replace(/:/g, '')
      : 0;
    //console.log('this.props.selectId',this.props.selectId)
    return (
      <div className={classes.Input}>
        <label className={classes.Label}></label>
        <select
          aria-label={this.props.selectId}
          id={this.props.selectId}
          className={classes.InputElement}
          size="1"
          value={this.state.time}
          onChange={this.handleTimeChange}
        >
          {Object.entries(this.hours).map((hour) => (
            <option
              selected={
                disableValue > 0 && disableValue === hour[0].replace(/:/g, '')
                  ? true
                  : null
              }
              disabled={
                (disableValue > 0 &&
                  disableValue >= hour[0].replace(/:/g, '')) ||
                this.props.time === '' ||
                (this.props.selectId === 'startTime' &&
                  hour[0].replace(/:/g, '') === '2359') ||
                (this.props.selectId === 'endTime' &&
                  hour[0].replace(/:/g, '') === '0000')
                  ? true
                  : null
              }
              data-key={hour[0].replace(/:/g, '')}
              key={hour[0]}
              value={hour[0]}
            >
              {hour[1]}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

export default TimeSelect;
